import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "grow ml-2"
};
const _hoisted_2 = {
  key: 0,
  class: "ml-1"
};
import { Team } from "@/modules/team/entity";
import GlobalSearchLayout from "@/modules/global-search/pages/GlobalSearchLayout.vue";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import TeamColors from "@/modules/team/components/TeamColors.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalTeamsIndexPage',
  setup(__props) {
    const query = ref(Team.createQueryBuilder('team').innerJoinAndSelect('team.country', 'country'));
    return (_ctx, _cache) => {
      const _component_NTag = _resolveComponent("NTag");
      return _openBlock(), _createBlock(GlobalSearchLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('search_teams')), 1)]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          query: query.value
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, team => {
            return _openBlock(), _createElementBlock("div", {
              key: team.id,
              class: "flex items-center w-full py-1 even:bg-slate-50"
            }, [_createVNode(Flag, {
              country: team.country
            }, null, 8, ["country"]), _createVNode(TeamColors, {
              team: team,
              class: "ml-2"
            }, null, 8, ["team"]), _createElementVNode("div", _hoisted_1, [_createVNode(EntityLink, {
              entity: team
            }, null, 8, ["entity"])]), _ctx.$debug ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_NTag, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(Math.round(team.level)), 1)]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true)]);
          }), 128))]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});